export default "__VITE_ASSET__24c9e54a__"